import React from 'react';
import { TableCellProps } from '../../../types/search';
import { getStatusClass, capitalizedValue, addPaidDate } from '../utils/tableCellUtils';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PortalCellStatus: React.FC<TableCellProps> = ({ value, row, listingType }) => {
  const parentClass = listingType === 'jobs' ? 'status-pill' : 'portal-cell__pill';
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const statusClass = React.useMemo(() => getStatusClass(value, listingType), [value]);
  const status = listingType === 'invoices' ? addPaidDate(value, row.paidDate) : value;

  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--status`}>
      <span className={`${parentClass} ${parentClass}--${statusClass}`}>{capitalizedValue(status)}</span>
    </div>
  );
};

export default PortalCellStatus;
